import { createClient } from "./createClient";
import { createSimulations } from "./createSimulations";
import { getComplements } from "./getComplements";
import { getConsent } from "./getConsent";
import { getFiles } from "./getFiles";
import { getOperations } from "./getOperations";
import { getReceivedDates } from "./getReceivedDates";
import { postTransaction } from "./postTransaction";
import { uploadFiles } from "./uploadFiles";

export const crefisaService = {
  createClient,
  createSimulations,
  getComplements,
  getConsent,
  getFiles,
  getOperations,
  postTransaction,
  uploadFiles,
  getReceivedDates,
};
